import dynamic from 'next/dynamic'
import React, { useState, useCallback, useContext, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Container, useMediaQuery } from '@material-ui/core'
import MenuButton from '../../lib/react-storefront/menu/MenuButton'
import Button from '@material-ui/core/Button'
import Link from 'next/link'
import SessionContext from '../../contexts/SessionContext'
import Menu from '../../lib/react-storefront/menu/Menu'
import Box from '@material-ui/core/Box'
import { useRouter } from 'next/router'
import CentralUserButton from '../header/CentralUserButton'
import Search from '../search/Search'
import StoreDialog from '../StoreDialog'
import theme from '../theme'
import NavBar from './../NavBar'
import AppBar from '../header/AppBar'
import Image from 'next/image'
import CustomMenuLeaf from '../menu/CustomMenuLeaf'

const useStyles = makeStyles(theme => ({
  title: {},
  logo: {
    position: 'absolute',
    left: 10,
    top: -4,
    [theme.breakpoints.down('xs')]: {
      left: '50%',
      top: 0,
      transform: 'translate(-60%, 0%)',
    },
    [theme.breakpoints.only('sm')]: {
      position: 'relative',
      left: 0,
    },
  },
  toolbar: {
    padding: 0,
    margin: 0,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      padding: 5,
    },
  },
  storeNameColor: c => ({
    color: c.color,
  }),
  buttonCusBgColor: c => ({
    backgroundColor: c.backgroundColor,
    border: '1px solid ' + c.color,
  }),
}))

export default function CentralHeader({ menu, config, appData, isBottleZoo }) {
  const { session } = useContext(SessionContext)
  const router = useRouter()
  const { storeSlug } = router.query

  const themeColor = config?.web_theme_color || '#1e3041'
  const fontColor = config?.web_theme_font_color || '#fff'

  const c = {
    color: storeSlug && fontColor ? `${fontColor}` + ' !important' : '#fff',
    backgroundColor: `${themeColor}` + ' !important',
  }

  const classes = useStyles(c)
  const [menuOpen, setMenuOpen] = useState(false)
  const [menuTabs, setMenuTabs] = useState([])
  const handleMenuClose = useCallback(() => setMenuOpen(false), [])
  const handleMenuButtonClick = useCallback(() => setMenuOpen(open => !open), [])
  const [open, setOpen] = useState(false)
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'))
  const isMedium = useMediaQuery(theme.breakpoints.down('md'))

  const isCustomDomain = appData?.config?.isCustomDomain

  const logoClickHandler = (event) => {
    if (isCustomDomain) {
      event.preventDefault()
      if (router.pathname === '/store/[storeSlug]') {
        window.scrollTo(0, 0)
      } else {
        router.push(`/store/${storeSlug}`)
      }
      return
    }
    if (router.pathname === '/') {
      event.preventDefault()
      window.scrollTo(0, 0)
    } else {
      router.push('/')
    }
  }

  const handleClickOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const storeLink = isCustomDomain ? `/store/${storeSlug}` : (router.pathname === '/store/[storeSlug]' ? `/store/${storeSlug}` : '/')

  useEffect(() => {
    async function fetchTabs() {
      try {
        // Include store context in menu fetch
        const menuUrl = storeSlug ? `/api/menu?storeSlug=${storeSlug}` : '/api/menu';
        
        const res = await fetch(menuUrl)
        const items = await res.json()
        
        setMenuTabs(items)
      } catch (err) {
        console.error('[CentralHeader] Menu fetch failed:', err)
      }
    }
    fetchTabs()
  }, [storeSlug]) // Re-fetch when store changes

  return (
    <>
      <AppBar variant="fixed" className="cenheader-space">
        <Container maxWidth="lg" className={'header-sec-center ' + classes.container}>
          <Link href={storeLink} className="store-logo" title="Store Logo" onClick={logoClickHandler}>
            {config?.bizlogo ? (
              <Image src={config.bizlogo} width={88} height={100} className={'img-control ' + classes.logo} alt="Store Logo" />
            ) : (
              <span></span>
            )}
          </Link>

          {((appData?.stores?.length > 1) || isBottleZoo) && !isMedium && storeSlug && (
            <Box className="web-main-header">
              <NavBar
                isBottleZoo={isBottleZoo}
                tabs={menuTabs}
                themeColor={themeColor}
                fontColor={fontColor}
              />
              {!isCustomDomain && (
                <>
                  <Box className="search-section">{storeSlug && <Search />}</Box>
                  <Box className="user-actions change-store">
                    <StoreDialog stores={appData?.stores} open={open} setOpen={setOpen} />
                    {appData?.config && (
                      <Box className="top-address">
                        <h2 className={classes.storeNameColor}>{appData.config.bizname}</h2>
                      </Box>
                    )}
                    <Button
                      title="Change Store"
                      variant="contained"
                      color="primary"
                      onClick={handleClickOpen}
                      className={classes.buttonCusBgColor}
                    >
                      Change
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          )}

          {storeSlug && (
            <MenuButton open={menuOpen} onClick={() => {
              setMenuOpen(!menuOpen)
            }} />
          )}

          <Box className="user-actions">
            {isMedium && storeSlug && <Search />}
            {!isMedium && isCustomDomain && storeSlug && (
              <Box className="search-section"><Search /></Box>
            )}
            <CentralUserButton showcart={false} session={session} />
          </Box>
        </Container>
      </AppBar>

      <Menu
        anchor="right"
        root={{ items: menuTabs }}
        open={menuOpen}
        onClose={handleMenuClose}
        className="menu-blk"
        renderItem={(item, isLeaf) => {
          if (!item.items) {
            return <CustomMenuLeaf item={item} />
          }
          return null; // Let Menu handle branch items normally
        }}
      />
    </>
  )
}
